import { render, staticRenderFns } from "./StockOnHandItemReportView.vue?vue&type=template&id=1b4cae15"
import script from "./StockOnHandItemReportView.vue?vue&type=script&lang=js"
export * from "./StockOnHandItemReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports